<template>
  <Teleport to="body">
    <div v-if="modelValue" class="relative z-50">
      <!-- Fond sombre -->
      <div class="fixed inset-0 bg-black bg-opacity-25 transition-opacity" @click="handleClose"></div>

      <!-- Modal -->
      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <div class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <!-- Titre -->
            <h3 class="text-lg font-medium leading-6 text-gray-900 flex items-center gap-3">
              <AlertTriangleIcon class="h-6 w-6 text-red-500" />
              {{ title }}
            </h3>

            <!-- Message -->
            <div class="mt-4">
              <p class="text-sm text-gray-500">
                {{ message }}
              </p>
            </div>

            <!-- Bouton d'action -->
            <div class="mt-6 flex justify-end">
              <button
                class="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                @click="handleAction"
              >
                {{ actionText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { AlertTriangle as AlertTriangleIcon } from 'lucide-vue-next'

defineProps<{
  modelValue: boolean
  title: string
  message: string
  actionText?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'action'): void
}>()

const handleClose = () :void => {
  emit('update:modelValue', false)
}

const handleAction = () :void => {
  emit('action')
  handleClose()
}
</script> 